module.exports = __webpack_public_path__ + "img/diamante-negro.bdc318ce.png";